import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-do-weather',
  templateUrl: './weather.component.html',
  styleUrls: ['./weather.component.scss']
})
export class WeatherComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
